import { Link } from "react-router-dom";
import { ArrowUpRight, GraduationCap } from "lucide-react";
import { formationOrderHref } from "@/components/formation/FormationHome";
import { FORMATION_PRICE, formationPrice } from "@/lib/formation";
import { FORMATION_GUIDE_LINKS } from "@/lib/formationGuides";

const enUntil = () => new Date(FORMATION_PRICE.until).toLocaleString("en-GB", { day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris" });

/** Encadré des guides formation : lien ozentyaformation.com, prix de lancement tant qu'il est valable (rien ensuite). */
export function FormationGuideCta({ en = false, testid, className = "" }) {
  const p = formationPrice();
  return (
    <aside data-testid={testid} className={`rounded-sm border border-[var(--gold)] bg-[rgba(217,180,106,0.1)] p-6 md:p-8 ${className}`}>
      <div className="flex items-start gap-4">
        <GraduationCap className="mt-1 h-8 w-8 shrink-0 text-[var(--gold)]" aria-hidden="true" />
        <div>
          <p className="eyebrow mb-2">{en ? "Online course · Ozentya Method (in French)" : "Formation en ligne · Méthode Ozentya"}</p>
          <p className="text-sm leading-relaxed text-[var(--parchment)] md:text-base">
            {en ? "47 lessons in 7 modules by Pascal Chaubo, founder of Ozentya: understand afro hair, assess its needs and build suitable routines. At your own pace, lifetime access, certificate." : "47 leçons en 7 modules par Pascal Chaubo, fondateur d'Ozentya : comprendre le cheveu afro, analyser ses besoins et construire des routines adaptées. À votre rythme, accès à vie, certificat."}
          </p>
          {p ? (
            <p data-testid={`${testid}-price`} className="mt-4 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span className="font-display text-3xl text-[var(--gold-soft)]">{en ? `€${p.now}` : `${p.now} €`}</span>
              <span className="text-sm text-[var(--parchment)]/85">{en ? <>instead of <s>€{p.after}</s> until {enUntil()} (Paris time)</> : <>au lieu de <s>{p.after} €</s>, jusqu'au {p.until}</>}</span>
            </p>
          ) : null}
          <a href={formationOrderHref("guide-formation")} target="_blank" rel="noopener" data-testid={`${testid}-link`} className="group mt-5 inline-flex min-h-12 items-center gap-2 rounded-full bg-[var(--gold)] px-7 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ink)] transition-transform duration-300 hover:-translate-y-0.5">
            {en ? "Discover the course" : "Je découvre la formation"} <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </aside>
  );
}

export function FormationGuidesNav({ current }) {
  return (
    <nav data-testid="formation-guides-nav" aria-label="Guides formation" className="mt-20">
      <h2 className="eyebrow mb-5">Nos guides formation</h2>
      <div className="flex flex-wrap gap-2">
        {[...FORMATION_GUIDE_LINKS, { to: "/formation", label: "La formation Méthode Ozentya" }].filter((l) => l.to !== current).map((l) => (
          <Link key={l.to} to={l.to} data-testid={`formation-guide-link-${l.to.slice(1)}`} className="flex min-h-10 items-center rounded-full border border-[var(--gold)]/40 px-5 py-2 text-xs uppercase tracking-[0.18em] text-[var(--parchment)]/85 transition-colors hover:border-[var(--gold)] hover:text-[var(--gold-soft)]">{l.label}</Link>
        ))}
      </div>
    </nav>
  );
}
